import { autocompleteClasses, type Theme, menuItemClasses } from "@mui/material"
import { SuggestionsPaperTheme } from "core/themes/src/definitions/components.types"

export const createSuggestionsPaperTheme = (theme: Theme): SuggestionsPaperTheme => ({
    styleOverrides: {
        listElement: {
            "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
                borderColor: `${theme.palette.primary.main} ${theme.palette.primary.main} ${theme.palette.primary.main} transparent`,
            },
            [`&.${autocompleteClasses.option}`]: {
                margin: 0,

                [`&.${autocompleteClasses.focused}`]: {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
            },
        },
        root: {
            [`.${menuItemClasses.gutters}`]: {
                border: `1px solid transparent`,
                borderLeft: 0,
                padding: "2px 16px",
                "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                    borderColor: `${theme.palette.primary.main} ${theme.palette.primary.main} ${theme.palette.primary.main} transparent`,
                },
            },
        },
    },
    variants: [],
})
